import React from "react";

// Filter chip rows for /opportunities (extracted from Opportunities.jsx in
// the Phase 15 component split — behaviour unchanged). Filter definitions are
// module-scope constants so they aren't re-created on every render.

const TYPE_FILTERS = [
  { id: "all", label: "Everything" },
  { id: "org", label: "Charity roles" },
  { id: "community", label: "Community events" },
  { id: "help", label: "Help requests" },
];

export function TypeFilterChips({ type, onSelect }) {
  return (
    <div className="mt-6 flex flex-wrap gap-2" data-testid="opp-type-filter">
      {TYPE_FILTERS.map((t) => (
        <button
          key={t.id}
          data-testid={`type-filter-${t.id}`}
          onClick={() => onSelect(t.id)}
          className={`text-sm px-4 py-2 rounded-full border transition-colors ${type === t.id ? "bg-forest text-white border-forest" : "bg-white border-neutral-200 text-neutral-700 hover:border-forest/40"}`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}

const COMMITMENT_FILTERS = [
  { id: "micro", label: "⚡ Quick task", accent: true },
  { id: "one_off", label: "One-off" },
  { id: "recurring", label: "Recurring" },
  { id: "ongoing", label: "Ongoing" },
];

// Phase 18 item 1: quick-win chips — "Under an hour" and "This week".
// Server-side definition lives in services/quick_wins.py; these compose with
// each other and every other filter, and round-trip via URL params.
export function QuickWinChips({ quickWin, thisWeek, onToggleQuickWin, onToggleThisWeek }) {
  const cls = (on) =>
    `text-sm px-4 py-2 rounded-full border transition-colors ${on ? "bg-terracotta text-white border-terracotta" : "bg-white border-neutral-200 text-neutral-700 hover:border-terracotta/50"}`;
  return (
    <div className="mt-3 flex flex-wrap gap-2" data-testid="opp-quickwin-filter">
      <button data-testid="quick-filter-under-hour" onClick={onToggleQuickWin} className={cls(quickWin)}>
        Under an hour
      </button>
      <button data-testid="quick-filter-this-week" onClick={onToggleThisWeek} className={cls(thisWeek)}>
        This week
      </button>
    </div>
  );
}

export function CommitmentChips({ commitment, onToggle, onClear }) {
  return (
    <div className="mt-3 flex flex-wrap gap-2" data-testid="opp-commitment-filter">
      {COMMITMENT_FILTERS.map((c) => {
        const on = commitment.has(c.id);
        return (
          <button
            key={c.id}
            data-testid={`filter-chip-${c.id}`}
            onClick={() => onToggle(c.id)}
            className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${
              on
                ? c.accent
                  ? "bg-amber-100 text-amber-800 border-amber-300"
                  : "bg-forest text-white border-forest"
                : "bg-white border-neutral-200 text-neutral-700 hover:border-forest/40"
            }`}
          >
            {c.label}
          </button>
        );
      })}
      {commitment.size > 0 && (
        <button
          data-testid="filter-chip-clear"
          onClick={onClear}
          className="text-xs px-3 py-1.5 rounded-full text-neutral-500 hover:text-forest underline underline-offset-2"
        >
          Clear
        </button>
      )}
    </div>
  );
}
